module.exports = __webpack_public_path__ + "img/image7.c1da77a8.png";